module.exports = __webpack_public_path__ + "img/VCGMarkets-logo.387c57d0.png";